import React, {useMemo} from "react";
import {Navigate, useParams} from "react-router-dom";
import {hasSimplifiedLayout} from "../booking-utils";
import {AppLayout} from "../component/app-layout";
import {BookingContextProvider, useBooking} from "../context/booking";
import {isBlank, notBlank} from "../utils";
import {BookingDetails} from "./booking/booking-details";
import {BookingPayment} from "./booking/booking-payment";
import {BookingProlongation} from "./booking/booking-prolongation";
import {BookingDetailsSimplified} from "./booking/simplified/booking-details-simplified";

export function BookingRoutes() {
	return (
		<BookingContextProvider>
			<BookingShell />
		</BookingContextProvider>
	);
}

// The booking sub-views that {@link BookingShell} knows how to render. Anything else (e.g. the removed `/boxes`
// tap route, still reachable via an old bookmark or a back/forward history entry) is redirected to the detail
// view rather than rendering empty app chrome.
const KNOWN_VIEWS = ["payment", "prolong"];

function BookingShell() {
	const {tenantId, bookingId, view} = useParams<{ tenantId: string; bookingId: string; view: string }>();
	const {booking} = useBooking();

	const simplifiedLayout = useMemo(() => booking?.site !== undefined && hasSimplifiedLayout(booking.site), [
		booking?.site,
	]);

	if (notBlank(view) && !KNOWN_VIEWS.includes(view as string)) {
		return <Navigate to={`/${tenantId}/bookings/${bookingId}`} replace />;
	}

	return (
		<AppLayout
			showBrandingBar={!simplifiedLayout}
		>
			{booking !== undefined && !simplifiedLayout && (
				<>
					{isBlank(view) && <BookingDetails />}
					{view === "payment" && <BookingPayment />}
					{view === "prolong" && <BookingProlongation />}
				</>
			)}
			{booking !== undefined && simplifiedLayout && (
				<>
					{isBlank(view) && <BookingDetailsSimplified />}
					{view === "payment" && <BookingPayment />}
					{view === "prolong" && <BookingProlongation />}
				</>
			)}
		</AppLayout>
	);
}
